import React, { useState } from 'react'
import UpdateForm from './UpdateForm';
import { Button, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'

export default function FleetStandard() {
    const [lgShow, setLgShow] = useState(false);

    return (
        <>
            <div className="row">
                <div className="row my-3 ">
                    <div className="col-md-6">
                        <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
                            Fleet Standard
                        </Typography>
                    </div>

                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
                        <Modal
                            size="lg"
                            show={lgShow}
                            onHide={() => setLgShow(false)}
                            aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                                <Modal.Title id="example-modal-sizes-title-lg" >
                                    Instructions to Add/Delete Fleet Standard
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                                <style>{`
                                  .help-badge {
                                    padding: 4px 10px;
                                    border-radius: 16px;
                                    font-weight: 700;
                                    font-size: 12px;
                                    text-transform: uppercase;
                                    letter-spacing: 0.5px;
                                    margin-right: 10px;
                                  }
                                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                                  .badge-delete { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                                  
                                  .help-card-text {
                                    font-size: 14px;
                                    color: #4a5568;
                                    line-height: 1.5;
                                    margin-bottom: 16px;
                                  }
                                  .video-responsive-wrapper {
                                    position: relative;
                                    width: 100%;
                                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                                    border-radius: 8px;
                                    overflow: hidden;
                                    background: #000000;
                                  }
                                  .video-responsive-wrapper video {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                  }
                                  .accordion-button:not(.collapsed) {
                                    background-color: #f1f5f9;
                                    color: #1e293b;
                                  }
                                `}</style>

                                <Accordion defaultActiveKey="0" flush>

                                  {/* 1. CREATE FLEET STANDARD */}
                                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-create">Create</span>
                                      <strong>How to Create a Fleet Standard</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        To create a new Fleet Standard, select the <strong>Account Name</strong> from the dropdown and click <strong>Add New</strong>. Select the Car Category, Type, Transmission, and Air Conditioner options, then click <strong>Submit</strong> to create the Fleet Standard.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/fleet standard - create.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                  {/* 2. DELETE FLEET STANDARD */}
                                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-delete">Delete</span>
                                      <strong>How to Delete a Fleet Standard</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        Select the required account, hover over the fleet standard entry to delete, click the <strong>Delete icon</strong>, and confirm the pop-up prompt to permanently remove it.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/fleet standard - delete.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                </Accordion>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>

            <UpdateForm />
        </>
    );
}
